import { Dropdown, Tooltip } from "antd";
import React from "react";
import styles from "./_styles.less";
import { useSelector } from "react-redux";
import { isXSSelector } from "@/store/layout";
import { DownOutlined } from "@ant-design/icons";

function DropdownMenu({ children, menuProps, ...dropdownProps }) {
  return (
    <Dropdown menu={menuProps} overlayClassName="dropdown-content" {...dropdownProps}>
      {children}
    </Dropdown>
  );
}

const Button = ({ tooltipTitle = "", className, children, ...props }) => {
  const isXS = useSelector(isXSSelector);
  return (
    <Tooltip title={isXS && tooltipTitle}>
      <div className={`${styles["dropdown-button"]} ${className || ""}`} role="button" {...props}>
        <DownOutlined />
        {!isXS && <span>{children}</span>}
      </div>
    </Tooltip>
  );
};

DropdownMenu.Button = Button;
export default DropdownMenu;
